import { bytesToHex, hexToBytes, randomBytes } from '@noble/hashes/utils';
import { base64 } from '@scure/base';

export { bytesToHex, hexToBytes, randomBytes };

const enc = new TextEncoder();
const dec = new TextDecoder();

export const utf8 = (s) => enc.encode(s);
export const fromUtf8 = (b) => dec.decode(b);

export function now() { return Math.floor(Date.now() / 1000); }

export function isHex32(s) { return typeof s === 'string' && /^[0-9a-f]{64}$/.test(s); }
export function isHex64(s) { return typeof s === 'string' && /^[0-9a-f]{128}$/.test(s); }

/**
 * Base64, portable and strict.
 *
 * These were `Buffer.from(...)`, which does not exist in a browser -- so every
 * base64 path threw there: NIP-44 payloads, attachment keys, the encrypted key
 * backup, HTTP authorisation. Nothing caught it because the browser tests only
 * ever exercised plaintext broadcasts, where no base64 is involved.
 *
 * `@scure/base` is already a dependency, runs everywhere, and rejects
 * out-of-alphabet input rather than silently skipping it -- which is what makes
 * two implementations agree on what a payload means.
 */
export function b64encode(bytes) {
  return base64.encode(bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes));
}

export function b64decode(str) {
  if (typeof str !== 'string') throw new Error('invalid base64');
  try {
    return base64.decode(str);
  } catch {
    throw new Error('invalid base64');
  }
}

/** Constant-time-ish comparison for equal-length byte arrays. */
export function bytesEqual(a, b) {
  if (a.length !== b.length) return false;
  let diff = 0;
  for (let i = 0; i < a.length; i++) diff |= a[i] ^ b[i];
  return diff === 0;
}

/** First value of the first tag with the given name, or undefined. */
export function tagValue(event, name) {
  const t = event.tags?.find((t) => t[0] === name);
  return t ? t[1] : undefined;
}

/** All values of every tag with the given name. */
export function tagValues(event, name) {
  return (event.tags ?? []).filter((t) => t[0] === name).map((t) => t[1]);
}
